import React, { useRef, useState, useEffect } from 'react'
// import t1 from '../../../assets/images/testimonials/t1.jpeg'
// import t2 from '../../../assets/images/testimonials/t2.jpeg'
// import t3 from '../../../assets/images/testimonials/t3.jpeg'
// import t4 from '../../../assets/images/testimonials/t4.jpeg'
// import t5 from '../../../assets/images/testimonials/t5.jpeg'
// import t6 from '../../../assets/images/testimonials/t6.jpeg'
// import t7 from '../../../assets/images/testimonials/t7.jpeg'

import tm1 from '../../../assets/images/testimonials/tm1.jpeg'
import tm2 from '../../../assets/images/testimonials/tm2.jpeg'
import tm3 from '../../../assets/images/testimonials/tm3.jpeg'
import tm4 from '../../../assets/images/testimonials/tm4.jpeg'
import tm5 from '../../../assets/images/testimonials/tm5.jpeg'
import tm6 from '../../../assets/images/testimonials/tm6.jpeg'

import './testimonials.css'

function Testimonials() {
  // const desktopTestimonials = [t1, t2, t3, t4, t5, t6, t7]
  const desktopTestimonials = [tm1, tm2, tm3, tm4, tm5, tm6]
  const mobileTestimonials = [tm1, tm2, tm3, tm4, tm5, tm6]
  const [isMobile, setIsMobile] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  //   const [activeIndex, setActiveIndex] = useState(0)
  const scrollRef = useRef(null)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const testimonials = isMobile ? mobileTestimonials : desktopTestimonials

  const handleImageClick = (testimonial, index) => {
    setSelectedImage({ src: testimonial, index })
  }

  const closeModal = () => {
    setSelectedImage(null)
  }

  //   const scrollToTestimonial = (index) => {
  //     setActiveIndex(index)
  //     if (scrollRef.current) {
  //       const testimonialItems = scrollRef.current.children
  //       if (testimonialItems[index]) {
  //         const scrollPosition =
  //           testimonialItems[index].offsetLeft -
  //           scrollRef.current.parentElement.offsetWidth / 2 +
  //           testimonialItems[index].offsetWidth / 2

  //         scrollRef.current.parentElement.scrollTo({
  //           left: scrollPosition,
  //           behavior: 'smooth',
  //         })
  //       }
  //     }
  //   }

  return (
    <div className='testimonials-section'>
      <h2 className='testimonials-title'>AI Meets Law — What Our Users Have to Say</h2>
      <div className='testimonials-container'>
        <div className='testimonials-scroll' ref={scrollRef}>
          {/* First set of images */}
          {testimonials.map((testimonial, index) => (
            <div
              key={`original-${index}`}
              className='testimonial-item'
              onClick={() => handleImageClick(testimonial, index)}
              style={{ cursor: 'pointer' }}
            >
              <img src={testimonial} alt={`Testimonial ${index + 1}`} />
            </div>
          ))}
          {/* Duplicate set for seamless loop */}
          {testimonials.map((testimonial, index) => (
            <div
              key={`duplicate-${index}`}
              className='testimonial-item'
              onClick={() => handleImageClick(testimonial, index)}
              style={{ cursor: 'pointer' }}
            >
              <img src={testimonial} alt={`Testimonial ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
      {/* <div className="testimonials-dots">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`dot ${activeIndex === index ? 'active' : ''}`}
            onClick={() => scrollToTestimonial(index)}
            aria-label={`View testimonial ${index + 1}`}
          />
        ))}
      </div> */}

      {/* Modal for enlarged image on mobile */}
      {selectedImage && (
        <div className='testimonial-modal' onClick={closeModal}>
          <div className='testimonial-modal-content' onClick={(e) => e.stopPropagation()}>
            <button className='testimonial-modal-close' onClick={closeModal}>
              ×
            </button>
            <img
              src={selectedImage.src}
              alt={`Testimonial ${selectedImage.index + 1}`}
              className='testimonial-modal-image'
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Testimonials
